export function Battery(props: Readonly<{ batteryLevel: number }>) {
  let textColor = '#151d48';
  if (props.batteryLevel >= 30 && props.batteryLevel <= 50) {
    textColor = '#FFC700';
  } else if (props.batteryLevel < 30) {
    textColor = '#D3180C';
  }
  return (
    <>
      <p className="text-basic d-flex align-items-center" style={{ color: textColor }}>
        <img src="/theme/media/battery.svg" height="19" alt="Battery" className={'me-1'} />
        {props.batteryLevel.toFixed()}%
      </p>
    </>
  );
}
